"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mockEspoolConfigurationModel = exports.mockEspoolRightChildConfigModel = exports.mockEspoolLeftChildConfigModel = exports.mockEspoolLinearChildConfigModel = void 0;
const echain_shared_articles_1 = require("@igus/echain-shared-articles");
const echain_shared_articles_oo_1 = require("@igus/echain-shared-articles-oo");
exports.mockEspoolLinearChildConfigModel = {
    AEs: [],
    AverageEnvironmentTemperatur: { Unit: '°C', Value: 20 },
    Bezeichnung: { 'de-DE': 'Ihr konfiguriertes igus® e-ketten® System' },
    ChildRelation: { Position: 'linear' },
    ConfigurationStartedWith: 'kette',
    DomainVersion: '0.0.1',
    FileRefs: [],
    Fuehrungsrinnen: [],
    IAs: [],
    IaArrangement: 'single',
    IgusGUIds: [],
    IsAlienConfiguration: false,
    IsIgnoreSafetyDistance: false,
    IsStackingOfLeitungenAllowed: true,
    Kette: echain_shared_articles_oo_1.Kette.fromJson(echain_shared_articles_1.espoolKetteJsons[0]).toModel(),
    Konfektionierungen: [],
    LeitungBomBehavior: 'UseAll',
    Leitungen: [],
    MontBes: [],
    MontageSets: [],
    PdfRefs: [],
    QuoteCount: 1,
    UseSameIAColorAndMaterial: false,
    Verpackungen: [],
    Zugentlastungen: [],
};
exports.mockEspoolLeftChildConfigModel = {
    AEs: [],
    AverageEnvironmentTemperatur: { Unit: '°C', Value: 20 },
    Bezeichnung: { 'de-DE': 'Ihr konfiguriertes igus® e-ketten® System' },
    ChildRelation: { Position: 'left' },
    ConfigurationStartedWith: 'kette',
    DomainVersion: '0.0.1',
    FileRefs: [],
    Fuehrungsrinnen: [],
    IAs: [],
    IaArrangement: 'single',
    IgusGUIds: [],
    IsAlienConfiguration: false,
    IsIgnoreSafetyDistance: false,
    IsStackingOfLeitungenAllowed: true,
    Kette: echain_shared_articles_oo_1.Kette.fromJson(echain_shared_articles_1.espoolKetteJsons[1]).toModel(),
    Konfektionierungen: [],
    LeitungBomBehavior: 'UseAll',
    Leitungen: [],
    MontBes: [],
    MontageSets: [],
    PdfRefs: [],
    QuoteCount: 1,
    UseSameIAColorAndMaterial: false,
    Verpackungen: [],
    Zugentlastungen: [],
};
exports.mockEspoolRightChildConfigModel = {
    AEs: [],
    AverageEnvironmentTemperatur: { Unit: '°C', Value: 20 },
    Bezeichnung: { 'de-DE': 'Ihr konfiguriertes igus® e-ketten® System' },
    ChildRelation: { Position: 'right' },
    ConfigurationStartedWith: 'kette',
    DomainVersion: '0.0.1',
    FileRefs: [],
    Fuehrungsrinnen: [],
    IAs: [],
    IaArrangement: 'single',
    IgusGUIds: [],
    IsAlienConfiguration: false,
    IsIgnoreSafetyDistance: false,
    IsStackingOfLeitungenAllowed: true,
    Kette: echain_shared_articles_oo_1.Kette.fromJson(echain_shared_articles_1.espoolKetteJsons[1]).toModel(),
    Konfektionierungen: [],
    LeitungBomBehavior: 'UseAll',
    Leitungen: [],
    MontBes: [],
    MontageSets: [],
    PdfRefs: [],
    QuoteCount: 1,
    UseSameIAColorAndMaterial: false,
    Verpackungen: [],
    Zugentlastungen: [],
};
exports.mockEspoolConfigurationModel = {
    AEs: [],
    AverageEnvironmentTemperatur: { Unit: '°C', Value: 20 },
    Bezeichnung: { 'de-DE': 'Ihr konfiguriertes igus® e-ketten® System' },
    Children: [exports.mockEspoolLinearChildConfigModel, exports.mockEspoolLeftChildConfigModel, exports.mockEspoolRightChildConfigModel],
    ConfigurationStartedWith: 'kette',
    DomainVersion: '0.0.1',
    Espool: echain_shared_articles_oo_1.Espool.fromJson(echain_shared_articles_1.espoolCenterMock).toModel(),
    FileRefs: [],
    Fuehrungsrinnen: [],
    IAs: [],
    IaArrangement: 'single',
    IgusGUId: 'IQU50-10000',
    IgusGUIds: [{ creationTimestamp: 1642756643563, dirty: false, expired: false, exposed: false, id: 'IQU50-10000' }],
    IsAlienConfiguration: false,
    IsIgnoreSafetyDistance: false,
    IsStackingOfLeitungenAllowed: true,
    Konfektionierungen: [],
    LeitungBomBehavior: 'UseAll',
    Leitungen: [],
    MontBes: [],
    MontageSets: [],
    PdfRefs: [],
    QuoteCount: 1,
    SplitPositionX: 0,
    UseSameIAColorAndMaterial: false,
    Verpackungen: [],
    Zugentlastungen: [],
};
//# sourceMappingURL=espoolConfiguration.mock.js.map